import(/* webpackMode: "eager", webpackExports: ["DesktopMenu"] */ "/app/apps/no-ga/src/app/_components/SideMenu/DesktopMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileMenu"] */ "/app/apps/no-ga/src/app/_components/SideMenu/MobileMenu.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/cookies-next@6.1.1_next@15.5.9_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+_e9f275ef062fcfd12a27b5a2f25fb3fc/node_modules/cookies-next/lib/client/context.js");
